import { useContext } from "react"

import { NotificationContactsContext } from "../../../components/Randomization/Notification/NotificationContactsProvider"

export const useNotificationContacts = () => {
  const notificationContactsContext = useContext(NotificationContactsContext)

  if (!notificationContactsContext) {
    throw new Error("useNotificationContacts must be used within a NotificationContactsProvider")
  }

  return notificationContactsContext
}
